import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file_download",
  "use": "icon-file_download-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-file_download\"><path d=\"M529.7 213.3H896a42.7 42.7 0 0 1 42.7 42.7v597.3A42.7 42.7 0 0 1 896 896H128a42.7 42.7 0 0 1-42.7-42.7V170.7A42.7 42.7 0 0 1 128 128h316.3l85.3 85.3z m-359 0v597.3h682.7V298.7h-359l-85.3-85.3H170.7z m384 341.3h128L512 725.3 341.3 554.6h128V384h85.3v170.7z\" p-id=\"10365\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/file_download.svg
// module id = 4h89
// module chunks = 39